export const AcknowledgeProps = { 'item.acknowledged': true };
export const EventSelectedProps = { 'event-selected': true };
export const EventOpenedProps = { 'opened-item': 'item' };
export const CardOpenedProps = { 'opened-item': 'card' };
export const AcknowledgeAndEventSelectedProps = { 'item.acknowledged': true, 'event-selected': true };
